class CartDocumentType extends HTMLElement {
  constructor() {
    super();

    this.documentTypeSelectors = this.querySelectorAll('.document-type-selector');
    this.billingMenu = this.querySelector('.billing-menu');
    this.billingInputs = this.querySelectorAll('.billing-menu input');
    this.rutInput = this.querySelector('#rut');
    this.checkoutButton = document.querySelector('[type="submit"][name="checkout"][form="cart"]');

    this.documentTypeSelectors.forEach((selector) => {
      selector.addEventListener('change', this.onChangeDocumentType.bind(this));
    });

    this.billingInputs.forEach((input) => {
      input.addEventListener('input', this.validateFields.bind(this));
      input.addEventListener('change', this.validateFields.bind(this));
      input.addEventListener('keyup', this.validateFields.bind(this));
    });

    if (this.rutInput) {
      this.rutInput.addEventListener('input', this.validateRut.bind(this));
    }

    this.onChangeDocumentType();
  }

  get selectedDocumentType() {
    return this.querySelector('.document-type-selector:checked')?.value;
  }

  onChangeDocumentType() {
    if (this.selectedDocumentType === 'factura') {
      this.billingMenu?.classList.add('show');
      this.billingInputs.forEach((input) => {
        input.required = true;
      });
    } else {
      this.billingMenu?.classList.remove('show');
      this.billingInputs.forEach((input) => {
        input.required = false;
        input.value = '';
        input.classList.remove('valido', 'invalido');
        input.setCustomValidity('');
      });
    }

    this.validateRut();
    this.validateFields();
  }

  validateRut() {
    if (!this.rutInput) return true;

    if (this.selectedDocumentType !== 'factura') {
      this.rutInput.classList.add('valido');
      this.rutInput.classList.remove('invalido');
      this.rutInput.setCustomValidity('');
      return true;
    }

    var valor = this.rutInput.value.replace(/\./g, '').replace('-', '');
    var cuerpo = valor.slice(0, -1);
    var dv = valor.slice(-1).toUpperCase();

    if (valor !== '') {
      this.rutInput.value = cuerpo + '-' + dv;
    }

    if (cuerpo.length < 7) {
      this.rutInput.classList.add('invalido');
      this.rutInput.classList.remove('valido');
      this.rutInput.setCustomValidity('RUT Incompleto');
      return false;
    } else {
      this.rutInput.classList.add('valido');
      this.rutInput.classList.remove('invalido');
      this.rutInput.setCustomValidity('');
    }

    var suma = 0;
    var multiplo = 2;
    for (var i = 1; i <= cuerpo.length; i++) {
      var index = multiplo * valor.charAt(cuerpo.length - i);
      suma += index;
      multiplo = (multiplo < 7) ? multiplo + 1 : 2;
    }

    var dvEsperado = 11 - (suma % 11);
    dv = dv === 'K' ? 10 : dv;
    dv = dv === 0 ? 11 : dv;

    if (dvEsperado !== parseInt(dv, 10)) {
      this.rutInput.classList.add('invalido');
      this.rutInput.classList.remove('valido');
      this.rutInput.setCustomValidity('RUT Inválido');
      return false;
    } else {
      this.rutInput.classList.add('valido');
      this.rutInput.classList.remove('invalido');
      this.rutInput.setCustomValidity('');
    }

    return true;
  }

  validateFields() {
    var fieldsCompleted = true;

    if (this.selectedDocumentType === 'factura') {
      this.billingInputs.forEach((input) => {
        if (input.value.trim() === '' || (input.id === 'rut' && !input.classList.contains('valido'))) {
          fieldsCompleted = false;
        }
      });
    }

    if (this.checkoutButton) {
      this.checkoutButton.disabled = !fieldsCompleted;
    }

    return fieldsCompleted;
  }
}

if (!customElements.get('cart-document-type')) {
  customElements.define('cart-document-type', CartDocumentType);
}
